module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-11-9c72b5f9aac31a9a947afd0616cefc3b.jpg";